var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.is_owner)?_c('div',{staticClass:"j-center"},[_c('h3',{staticClass:"m-b-0"},[_c('strong',[_vm._v("Total: "+_vm._s(_vm.price(_vm.total)))])]),(_vm.hasExtencion('ventas_en_dolares'))?_c('h3',{staticClass:"m-b-0 m-l-30"},[_c('strong',[_vm._v("Total USD: "+_vm._s(_vm.price(_vm.total_usd)))])]):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }